"use client";

import React from "react";
import { UserRound, Users, Briefcase, Landmark, Building2, FileText } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Checkbox } from "@/components/ui/checkbox";
import { Label } from "@/components/ui/label";
import { Separator } from "@/components/ui/separator";
const categories = [{
  id: "cat-1",
  title: "Existing Estate Documents",
  icon: "Governing Documents"
}, {
  id: "cat-2",
  title: "Family & Beneficiary Information",
  icon: "Users"
}, {
  id: "cat-3",
  title: "Personal Representative",
  icon: "UserRound"
}, {
  id: "cat-4",
  title: "Real Estate & Property",
  icon: "Building2"
}, {
  id: "cat-5",
  title: "Financial Information",
  icon: "FProbate or Court Information"
}, {
  id: "cat-6",
  title: "Business Interests",
  icon: "Briefcase"
}];
const checklistItems = [{
  categoryId: "cat-1",
  items: ["Original Will (if available)", "Trust documents", "Powers of Attorney", "Living Will / Health Care documents"]
}, {
  categoryId: "cat-2",
  items: ["Names of beneficiaries", "Names of heirs", "Surviving spouse information", "Minor children (if applicable)"]
}, {
  categoryId: "cat-3",
  items: ["Preferred Personal Representative", "Alternate Personal Representative"]
}, {
  categoryId: "cat-4",
  items: ["Property deeds", "Real estate addresses", "Vehicle titles", "Other titled property"]
}, {
  categoryId: "cat-5",
  items: ["Bank accounts", "Investment accounts", "Insurance policies", "Retirement accounts", "Beneficiary designations"]
}, {
  categoryId: "cat-6",
  items: ["Business ownership documents", "Operating Agreement", "Corporate records", "Buy-Sell Agreements"]
}];
function getIcon(name: string) {
  switch (name) {
    case "UserRound":
      return <UserRound className="h-5 w-5 text-secondary" />;
    case "Users":
      return <Users className="h-5 w-5 text-secondary" />;
    case "Briefcase":
      return <Briefcase className="h-5 w-5 text-secondary" />;
    case "Landmark":
      return <Landmark className="h-5 w-5 text-secondary" />;
    case "Building2":
      return <Building2 className="h-5 w-5 text-secondary" />;
    case "FileText":
      return <FileText className="h-5 w-5 text-secondary" />;
    default:
      return <FileText className="h-5 w-5 text-secondary" />;
  }
}
export default function ConsultationPreparation() {
  return <section id="consultationpreparation" className="bg-background py-16 text-foreground md:py-20 lg:py-24">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <div className="mb-12 max-w-3xl">
          <h2 className="mb-6 font-serif text-3xl font-semibold tracking-tight text-primary md:text-4xl">
            What to Prepare Before a Consultation
          </h2>

          <Separator className="mb-6 h-1 w-20 bg-secondary" />

          <p className="text-lg leading-relaxed text-muted-foreground">
            Probate matters begin with organized information. Bringing the
            available documents and basic information below helps make the
            initial consultation more efficient and focused.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
          {categories.map(category => {
          const section = checklistItems.find(x => x.categoryId === category.id);
          return <Card key={category.id} className="border-border/60 shadow-sm transition-shadow hover:shadow-md">
                <CardHeader>
                  <CardTitle className="flex items-center gap-3 font-serif text-xl text-primary">
                    {getIcon(category.icon)}
                    {category.title}
                  </CardTitle>
                </CardHeader>

                <CardContent>
                  <ul className="space-y-3">
                    {section?.items.map((text, index) => <li key={index} className="flex items-start gap-3">
                        <Checkbox id={`${category.id}-${index}`} className="mt-0.5 h-5 w-5 shrink-0 rounded-sm border-muted-foreground/40 data-[state=checked]:border-secondary data-[state=checked]:bg-secondary" />

                        <Label htmlFor={`${category.id}-${index}`} className="cursor-pointer leading-relaxed text-muted-foreground transition-colors hover:text-foreground">
                          {text}
                        </Label>
                      </li>)}
                  </ul>
                </CardContent>
              </Card>;
        })}
        </div>
      </div>
    </section>;
}